/**
 * Shared customer FAQ copy (Contact page + /faq).
 * Single source of truth for accordion items.
 */
// KAN-252 — SUG9 dedicated FAQ page + Contact reuse

import { LEAD_TIME_BUSINESS_DAYS_TEXT } from '../config/leadTime';

export type CustomerFaqItem = { q: string; a: string };

export const CUSTOMER_FAQ_ITEMS: CustomerFaqItem[] = [
  {
    q: 'What types of foam do you offer?',
    a: 'We work primarily with closed-cell polyethylene (PE) foam, available in multiple densities (2 lb, 4 lb, 6 lb, and 9 lb). We also offer cross-linked PE foam, anti-static foam for ESD-sensitive electronics, and convoluted (egg-crate) foam for lighter cushioning applications. Custom colors including black, charcoal, blue, and olive drab are available.',
  },
  {
    q: 'How long does it take to get a custom foam insert?',
    a: `Typical turnaround for CNC-cut foam inserts is ${LEAD_TIME_BUSINESS_DAYS_TEXT} after design approval. Rush orders can often be accommodated within 1-2 business days. Full custom case builds with integrated foam typically take 2-4 weeks depending on complexity.`,
  },
  {
    q: 'Is there a minimum order quantity?',
    a: 'No. We accept single-unit orders all the way up to production runs of thousands. Pricing scales with quantity, so larger orders receive volume discounts. Contact us for a quote on your specific requirements.',
  },
  {
    q: 'Which case brands are compatible with your foam inserts?',
    a: "Our foam inserts are compatible with cases from Pelican, SKB, Nanuk, Apache, Seahorse, Storm, HPRC, Explorer, Condition 1, Plano, and many more. Our CaseBuilder tool includes templates for 125+ models. If your case isn't listed, you can enter custom dimensions.",
  },
  {
    q: 'How does the online CaseBuilder design tool work?',
    a: 'Select a case model (or enter custom dimensions), then use the drag-and-drop 2D editor to place and size cutout shapes for your equipment. You can trace shapes from uploaded photos, preview your layout in 3D, and export as PNG, SVG, or production-ready DXF. When ready, submit your design for a manufacturing quote directly from the tool.',
  },
  {
    q: 'What file formats can I use or export?',
    a: 'The CaseBuilder tool exports designs as PNG (for sharing), SVG (for vector editing), and DXF (for CNC manufacturing). If you have existing CAD drawings in DXF or DWG format, our team can work from those as well.',
  },
  {
    q: 'Do you ship internationally?',
    a: 'Yes, we ship worldwide. Domestic orders ship via UPS or FedEx with tracking. International orders are available via standard carrier services. Contact us for international shipping quotes.',
  },
  {
    q: 'Can you do laser engraving or branding on cases?',
    a: 'Yes. We offer laser engraving, silk screening, and custom labeling on case exteriors. This includes logos, part numbers, NSN markings, and custom text. See our Products page for branding service details or contact us for pricing.',
  },
  {
    q: 'What is your return / revision policy?',
    a: 'If a foam insert does not match your approved design specifications, we will recut it at no charge. Because inserts are custom-manufactured, we cannot accept returns on correctly produced items. We strongly recommend using the 3D preview feature to verify your layout before submitting.',
  },
  {
    q: 'Do you offer MIL-STD and IP-rated cases?',
    a: 'Yes. Many of the cases we work with meet MIL-STD-810 for shock, vibration, and environmental testing, as well as IP67 (watertight and dustproof) ratings. We can help you select the right case and foam configuration for your compliance requirements.',
  },
];
